import React from "react";

export default function WhatIf({ setCurrentStep }) {
  return (
    <div className="w-full max-w-[400px] mx-auto p-6 bg-white min-h-[100dvh] flex flex-col items-center justify-center font-atkinson">
      <div className="bg-gray-100 p-6 rounded-2xl w-full border-2 border-dashed border-gray-400">
        <h2 className="text-xl font-bold text-center mb-2 text-black">
          🛠️ Mock Routing Page
        </h2>
        <p className="text-center text-[14px] text-gray-600 mb-8">
          This page is for frontend review only. Choose a path to test the flow.
        </p>

        {/* Routes to standard PL flow (Step 6 skips the old AA steps) */}
        <button
          onClick={() => setCurrentStep(6)} 
          className="w-full bg-[#12f280] text-black font-bold text-[18px] rounded-[18px] py-4 mb-4 active:scale-95 transition-transform shadow-md"
        >
          ✅ User is Eligible for PL
        </button>

        {/* Routes to Gold Loan Offers (Step 4) */}
        <button
          onClick={() => setCurrentStep(4)} 
          className="w-full bg-black text-white font-bold text-[18px] rounded-[18px] py-4 active:scale-95 transition-transform shadow-md"
        >
          💰 Show Gold Loan Offers
        </button>
      </div>
    </div>
  );
}